import {combineReducers} from 'redux';
import authReducer from './authReducer';
import batchReducer from './batchReducer';
import coverNoteReducer from './coverNoteReducer';
import enquiryReducer from './enquiryReducer';
import errorCodeReducer from './errorCodeReducer';
import policyReducer from './policyReducer';
import qrCodeReducer from './qrCodeReducer';
import userManagementReducer from './userManagementReducer';
import configReducer from './configReducer';

export default combineReducers({
    auth: authReducer,
    coverNote: coverNoteReducer,
    policy: policyReducer,
    qrCode: qrCodeReducer,
    batch: batchReducer,
    enquiry: enquiryReducer,
    errorCode: errorCodeReducer,
    userManagement: userManagementReducer,
    config: configReducer
});


// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/rootReducer.ts